angular.module('summonApp.controllers')
   .factory('libraryCardErrorHelper', function () {
      return {
         getLibraryCardErrorMessage(err: any, sierraService: any, i18n: any) {
            if (sierraService.libraryCardUnavailable) {
               return i18n.translations.LOG_IN_ERROR_SIERRA
            }
            return err?.data?.message || i18n.translations.REQUEST_ERROR_UNKNOWN
         }
      }
   })